module.exports = __webpack_public_path__ + "static/img/icon_share.7e3fc0a5.png";